export const isEnv = (env: string) => process.env.NODE_ENV === env;

export const isDev = () => !process.env.NODE_ENV || isEnv('development');

export const isProd = () => isEnv('production');

export const isValidDate = (date: Date): boolean => {
  return date instanceof Date && !isNaN(date.getTime());
};
